import { Link } from "react-router-dom";
import { NavDropdown } from "react-bootstrap";

import { hasRole } from "../../services/wp.user.service";

import navLinks from "./LoggedInMenu.json";
import { useAuth } from "../../services/wp.auth.service";
import { useMemo } from "react";
import { userCanRegister } from "../../helpers/authHelpers";

/* eslint-disable react/jsx-closing-tag-location */
const LoggedInDropdown = () => {
	const { user } = useAuth();
	const canRegister = useMemo(() => userCanRegister(user), [user]);

	return (
		<NavDropdown className="fw-bold py-2 px-4 bg-darkblue" title={"My Account"}>
			{/* eslint-disable-next-line no-extra-parens */}
			{navLinks.map((link) => (!link.attendeesOnly || (link.attendeesOnly && canRegister)) && (
				<NavDropdown.Item as={Link} key={link.to} to={link.to}>
					{link.text}
				</NavDropdown.Item>
			))}

			<NavDropdown.Divider />

			{ hasRole("facilitator", user) && <>
				<NavDropdown.Header>Facilitators</NavDropdown.Header>
				<NavDropdown.Item as={Link} to="/facilitator">
					Dashboard
				</NavDropdown.Item>
				<NavDropdown.Item as={Link} to="/facilitator/future-events">
					Upcoming Events
				</NavDropdown.Item>
				<NavDropdown.Item as={Link} to="/facilitator/past-events">
					Past Events
				</NavDropdown.Item>

				<NavDropdown.Divider />
			</>}

			{ hasRole("administrator") && <>
				<NavDropdown.Item as={Link} to="/wp-admin">
					Admin
				</NavDropdown.Item>

				<NavDropdown.Divider />
			</>}

			<NavDropdown.Item as={Link} to="/logout">
				Logout
			</NavDropdown.Item>
		</NavDropdown>
	);
};

export default LoggedInDropdown;
